import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import TableRow from "@mui/material/TableRow";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import {
  deleteInstitution,
  createInstitution,
} from "../../actions/institution";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { message, Popconfirm } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  color: "black",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  { id: "institution", label: "Institution", minWidth: 100, align: "left" },
  { id: "code", label: "Code", minWidth: 100, align: "left" },
];
function createData(id, institution, code) {
  return { id, institution, code };
}
export default function Institution() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [institution, setInstitution] = React.useState({
    institution: "",
    code: "",
  });
  const institutions = useSelector((state) => state.institution);
  const rows = institutions.map((data) =>
    createData(data._id, data.institution, data.code)
  );

  // category.intangible_category = checked;
  const dispatch = useDispatch();

  function sendData() {
    if (!institution.institution && !institution.code) {
      toast.error("Please fill in required fields");
      return;
    }
    dispatch(createInstitution(institution));
    setTimeout(() => {
      setInstitution({ institution: "" });
    }, 1000);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  let allowManipulate = false;
  if (
    user.results.portfolio_manager === "Administrator" ||
    user.results.portfolio_manager === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }
  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px" }}>
                Add Institution
              </Typography>
              <form>
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='institution'
                  required
                  value={institution.institution}
                  onChange={(e) =>
                    setInstitution({
                      ...institution,
                      institution: e.target.value,
                    })
                  }
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Code'
                  required
                  value={institution.code}
                  onChange={(e) =>
                    setInstitution({
                      ...institution,
                      code: e.target.value,
                    })
                  }
                />

                <div>
                  <Button
                    onClick={sendData}
                    variant='contained'
                    size='small'
                    style={{
                      textTransform: "none",
                      margin: "5px",
                      backgroundColor: "#333D51",
                    }}>
                    Submit
                  </Button>
                  <Button
                    variant='contained'
                    style={{
                      textTransform: "none",
                      backgroundColor: "#D32F2F",
                    }}
                    onClick={handleClose}
                    size='small'>
                    Cancel
                  </Button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Button
          disabled={!allowManipulate}
          size='small'
          style={{
            textTransform: "capitalize",
            margin: "5px",
          }}
          onClick={handleOpen}
          variant='contained'>
          Add institution
        </Button>
        <em style={{ color: "red" }}>
          {allowManipulate
            ? ""
            : "you don't have the permission to add asset pool"}
        </em>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table
            size='small'
            stickyHeader
            aria-label='sticky table'
            // style={{ backgroundColor: "#E9F1F7" }}
            sx={{
              "& tr > *:last-child": {
                position: "sticky",
                right: 0,

                // bgcolor: "#cccc",
              },
            }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#f8f8f8",
                      color: "#000000",
                      fontWeight: "bold",
                    }}>
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  style={{
                    backgroundColor: "#f8f8f8",
                    color: "#000000",
                    fontWeight: "bold",
                  }}>
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row) => {
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            fontSize: "14px",
                          }}>
                          <Popconfirm
                            title='Do you want to delete this institution?'
                            onConfirm={() =>
                              dispatch(deleteInstitution(row.id))
                            }
                            onCancel={() => {
                              message.info("Nothing was deleted");
                            }}>
                            <Tooltip title='Delete'>
                              <IconButton>
                                <DeleteIcon
                                  style={{ fontSize: "18px", color: "red" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Popconfirm>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
